import TranslationsFormBase from '@/Components/Admin/TranslationsFormBase';
import { mapObject } from '@/Utils';
import FormModelHelpers from '@/Mixins/FormModelHelpers';
import HighlighterHelpers from '@/Mixins/Admin/HighlighterHelpers';

export default {
    extends: TranslationsFormBase,
    mixins: [FormModelHelpers, HighlighterHelpers],
    data() {
        return {
            isEditing: false,
        };
    },
    methods: {
        handleError(error) {
            this.$notify.popupServerError(error);
        },
        initialize() {
            this.loadSettings().then(() => this.initializeHighlighter());
        },
        loadSettings() {
            return this.loadSettingsBase();
        },
        loadSettingsBase() {
            return this.wrapAsyncTask(this.loadSettingsPromise()
                .then(this.loadTranslationsPromise)
                .then(this.handleLoadSettingsPromiseResolved)
                .then(() => this.$validator.reset())
                .then(() => this.initialized()));
        },
        async loadTranslationsPromise(response) {
            if (response?.data) {
                response.data = await this.loadTranslationModel({
                    formType: this.translationFormType,
                    entityID: this.translationEntityId,
                    model: response.data,
                });

                return response;
            }
        },
        async loadTranslationsListPromise(response, fn = (x) => x) {
            if (response) {
                response.data = await this.loadTranslationModelList({
                    formType: this.translationFormType,
                    entityIDs: this.translationEntityIds,
                    model: response.data,
                }, fn);
                return response;
            }
        },
        updateModel(data) {
            mapObject(data, this.model);
        },
        handleLoadSettingsPromiseResolved(result) {
            if (result && result.data) {
                this.updateModel(result.data);
            }

            this.$nextTick(() => {
                this.hasChanged = false;
            });

            return this.onLoadSettingsSuccess(result ? result.data || null : null);
        },
        initialized() {
        },
        saveSettings() {
            this.$validator.resume();
            this.$validator.validateAll()
                .then(validationPassed => {
                    if (validationPassed) {
                        return Promise.resolve(this.confirmSaveSettingsPromise())
                            .then(beforeSavePassed => {
                                if (beforeSavePassed)
                                    this.wrapAsyncTask(this.wrapApiAction(this.saveSettingsPromiseManager(), 'model.')
                                        .then(response => {
                                            this.$notify.popupSuccess('Your changes have been saved.', { qa: 'ChangesSaved' });
                                            this.isEditing = false;
                                            // TODO: onSaveSuccessPromise should not handle redirects but it sometimes does
                                            // This has to be rewritten so loadSettings doesn't happen when we want to redirect
                                            // onSaveSuccessPromise has 16 references so this will be a separate task
                                            return this.onSaveSuccessPromise(response.data).then(this.loadSettings);
                                        }));
                            });
                    }
                });
        },
        saveSettingsPromiseManager() {
            if (!this.isDefaultLanguage) {
                if (this.translationList?.length > 0) {
                    return this.saveTranslationListPromise(this.translationList);
                }

                return this.saveTranslationPromise(this.model);
            }
            else {
                return this.saveSettingsPromise();
            }
        },
        confirmSaveSettingsPromise() {
            // Override in consumer component to do something right before saving data.
            // Return falsy promise to abort saving.
            // Useful for displaying confirmation dialogs.
            return Promise.resolve(true);
        },
        onLoadSettingsSuccess() {
            // by default do nothing
            // it could be overridden by other components
            return Promise.resolve();
        },
        onSaveSuccessPromise(responseData) {
            return Promise.resolve(true);
        },
        startEditing() {
            this.isEditing = true;
        },
        cancelEditing() {
            this.isEditing = false;
            this.loadSettings();
        },
    },
    mounted() {
        this.ensureStoreInitialized().then(this.initialize);
    },
};
